import type { ReactNode } from 'react';
import { cn } from '../../lib/utils';

export function Badge({ children, className }: { children: ReactNode; className?: string }) {
  return <span className={cn('inline-flex items-center rounded-full border border-gray-200 px-2 py-0.5 text-xs dark:border-gray-600', className)}>{children}</span>;
}

export function Tabs({ tabs, value, onChange, prominent = false }: { tabs: { id: string; label: string }[]; value: string; onChange: (id: string) => void; prominent?: boolean }) {
  if (prominent) {
    return (
      <div role="tablist" className="inline-flex flex-wrap gap-1 rounded-xl bg-gray-200 p-1.5 dark:bg-gray-800">
        {tabs.map((tab) => {
          const selected = value === tab.id;
          return (
            <button key={tab.id} type="button" role="tab" aria-selected={selected} className={cn('rounded-lg px-5 py-2.5 text-base font-semibold', selected ? 'bg-white text-[#895CF6] shadow-sm dark:bg-gray-950' : 'text-gray-600 hover:bg-white/70 hover:text-gray-900 dark:text-gray-300 dark:hover:bg-gray-700 dark:hover:text-white')} onClick={() => onChange(tab.id)}>{tab.label}</button>
          );
        })}
      </div>
    );
  }
  return (
    <div className="mb-6 flex w-fit flex-wrap gap-1 rounded-lg bg-gray-100 p-1 dark:bg-gray-800">
      {tabs.map((tab) => (
        <button key={tab.id} type="button" className={cn('rounded-md px-3 py-1.5 text-sm', value === tab.id ? 'bg-white font-medium shadow-sm dark:bg-gray-900' : 'text-gray-600')} onClick={() => onChange(tab.id)}>{tab.label}</button>
      ))}
    </div>
  );
}

export function Alert({ children, error = false }: { children: ReactNode; error?: boolean }) {
  return <div className={cn('mb-4 rounded-lg px-3 py-2 text-sm', error ? 'bg-red-50 text-red-700 dark:bg-red-950 dark:text-red-200' : 'bg-emerald-50 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-200')}>{children}</div>;
}
